import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/mechanism-info/mechanism-info.tsx");
